import { render, staticRenderFns } from "./online-updates.vue?vue&type=template&id=1a164872&scoped=true&"
import script from "./online-updates.vue?vue&type=script&lang=js&"
export * from "./online-updates.vue?vue&type=script&lang=js&"
import style0 from "./online-updates.vue?vue&type=style&index=0&id=1a164872&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a164872",
  null
  
)

export default component.exports